import * as React from "react";
import InputLabel from "@mui/material/InputLabel";
import Box from "@mui/material/Box";
import AccessModal from "../accessRequest"

import {
  CircularProgress,
  IconButton,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import InputAdornment from "@mui/material/InputAdornment";
import MenuItem from "@mui/material/MenuItem";
import ListItemText from "@mui/material/ListItemText";
import ClearIcon from "@mui/icons-material/Clear";
import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import CheckIcon from "@mui/icons-material/Check";
import Button from "@mui/material/Button";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllStatuses,
  getSearchedSellers,
  resetAll,
  resetSearchTerm,
  setCurrentStatus,

} from "../../redux/slices/sellerSlice";
import { useTheme } from "@emotion/react";
import {
  ACTIVESELLERMAPPING,
  REGISTEREDSELLERMAPPING,
  ROLES,
} from "../../utils/constants";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  autoFocus: false,
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

// const names = ["All", "Pending Approval", "Under Review", "Pending Activation"];

const Filter = ({sellerTab}) => {
  const dispatch = useDispatch();
  const theme = useTheme();

  const isMobile = useMediaQuery((theme) =>
    theme.breakpoints.between("sm", "md")
  );
  const isTablet = useMediaQuery((theme) =>
    theme.breakpoints.between("md", "lg")
  );

  const state = useSelector(
    ({
      seller: {
        statuses,
        loading,
        isInput,
        page,
        currentStatus,
        activeStatuses,
        msal: { user },
        msal: { roles },
        searchTerm

      },
    }) => ({
      statuses,
      loading,
      user,
      isInput,
      page,
      currentStatus,
      activeStatuses,
      roles,
      globalSearchTerm: searchTerm
    })
  );

  const hasAccess = state.roles.some(
    (role) =>
      role === ROLES.SUPER_ADMIN ||
      role === ROLES.BUSINESS_ADMIN ||
      role === ROLES.BUSINESS_USER ||
      role === ROLES.IT_ADMIN
  );


  const [searchTerm, setSearchTerm] = React.useState("");
  const [isValid, setIsValid] = React.useState(true);

  React.useEffect(() => {
    if (!hasAccess) return;
    state.user && dispatch(getAllStatuses());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.user, hasAccess]);

  React.useEffect(() => {
    if (sellerTab) {
      handleClearInput();
    }
    setSearchTerm('')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sellerTab])

  React.useEffect(() => {
    setSearchTerm(state.globalSearchTerm);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.globalSearchTerm]);

  const handleFilterChange = (event) => {
    const value =event.target.value;
    setSearchTerm(value);
    if (value.trim()) {
      setIsValid(true);
    } else {
      if(value==='') {
      // setIsValid(true);
      handleClearInput()
      } 
    }
    // setSearchTerm(event.target.value);
    // const data1 = data.filter((dat) =>
    //   dat.company_name.toLowerCase().includes(event.target.value.toLowerCase())
    // );
    // setData2(data1);
  };

  const handleFilterSubmit = () => {
    dispatch(resetAll())
    dispatch(
      getSearchedSellers({
        params: { searchTerm, offset: 0 },
        isInput: true,
      })
    );
    setIsValid(true);
  };

  const handleClearInput = () => {
    setSearchTerm("");

    dispatch(resetAll())

    dispatch(resetSearchTerm())

    dispatch(getSearchedSellers({
      params: { status: state.currentStatus, offset: 0 },
      isInput: false
    }))
  };

  const handleStatusChange = (event) => {
    if (state.currentStatus === event.target.value) return
    dispatch(resetAll())
    dispatch(
      getSearchedSellers({
        params: { status: event.target.value, offset: 0 },
        isInput: false,
      })
    );
    dispatch(setCurrentStatus({ currentStatus: event.target.value }));
  };

  const handleKeyDown = (e) => {
    if (e.which === 13 && e.shiftKey === false && searchTerm) {
      dispatch(resetAll())
      dispatch(
        getSearchedSellers({
          params: { searchTerm, offset: 0 },
          isInput: true,
        })
      );
      setIsValid(true);
    }
  }

  const registeredStatuses = REGISTEREDSELLERMAPPING.map((statusType) =>
    state.statuses?.find((item) => item.status_type === statusType)
  );

  const activeStatuses = ACTIVESELLERMAPPING.map((statusType) =>
    state.statuses?.find((item) => item.status_type === statusType)
  );

  const statusInput =
    state.statuses.find((item) => item.status_type === state.currentStatus) ||
    {};


  return (
    <>
      <>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            flexDirection: isMobile ? 'column': 'row',
          }}>{state.loading && !state.isInput ? null : 
          <Typography
            variant="h4"
            fontWeight={"600"}
            fontSize={(isMobile || isTablet) ? "1.8rem" : "2.25rem"}
            lineHeight={"2.625rem"}
            sx={{ mb:'1.5rem'}}
          >
            NDC Seller Admin
          </Typography>}
          {state.loading && !state.isInput ? null : 
          <AccessModal />}

        </Box>
        <Box
          sx={{
            display: "flex",
            ...((isMobile || isTablet) && { flexDirection: "column" }),
            columnGap: 10,
          }}
        >
          <Box
            sx={{
              display: "flex",
              columnGap: 3,
              mt:3,
              mb: 3.5,
              ...((isMobile || isTablet) && {
                flexDirection: isMobile ? "column" : "row",
                rowGap: 2,
                width: "100%",
              }),
            }}
          >
          {state.loading && !state.isInput ? null :
            <TextField
              type="text"
              label="Find Seller"
              value={searchTerm}
              onKeyDown={handleKeyDown}
              onChange={handleFilterChange}
              helperText={!isValid && "This field should not be empty"}
              error={!isValid}
              variant={"standard"}
              sx={{
                ...(isMobile || isTablet
                  ? { display: "flex", flex: 1 }
                  : { width: "18rem" })
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    {
                      <IconButton
                        sx={{ visibility: !searchTerm.length && "hidden" }}
                        onClick={handleClearInput}
                        aria-label="Clear seller"
                      >
                        <ClearIcon />{" "}
                      </IconButton>
                    }
                  </InputAdornment>
                ),
              }}
            />
          }
          {state.loading && !state.isInput ? null :
            <Button
              variant="contained"
               aria-label="Search seller"
              sx={{
                ...(isMobile || isTablet
                  ? { display: "flex", flex: 1 }
                  : { width: "6.5rem", maxHeight: "3rem" }),
                // width: isMobile ? "100%" : "6.5rem",
                boxShadow: "0 0 1rem #ccc",
                borderRadius: ".75rem",
              }}
              disabled={!searchTerm.length}
              onClick={handleFilterSubmit}
            >
              {state.loading && state.isInput ? (
                <CircularProgress
                  thickness={6}
                  size={"1rem"}
                  sx={{ color: theme.palette.primary.contrastText }}
                />
              ) : (
                <SearchIcon />
              )}
            </Button>}
          </Box>

          {(isMobile || isTablet) && !state.isInput && (
            <FormControl
              sx={{ display: "flex", width: isMobile ? "100%" : "50%", mb: 3 }}
              variant="standard"
            >{state.loading && !state.isInput ? null : 
              <InputLabel id="status-label">Seller Status</InputLabel>}
              {state.loading && !state.isInput ? null : 
              <Select
                labelId="status-label"
                id="demo-multiple-checkbox"
                value={`${statusInput.status_en} (${statusInput.count})`}
                onChange={handleStatusChange}
                sx={{ ...(isTablet && { mr: 3.5 }) }}
                renderValue={(selected) => {
                  return selected;
                }}
                MenuProps={MenuProps}
              >
                <MenuItem
                  disabled
                  sx={{
                    fontSize: ".8rem",
                    fontWeight: "bold",
                    background: "inherit",
                    opacity: "1 !important",
                    color: "black",
                  }}
                >
                  Registered Sellers
                </MenuItem>
                {registeredStatuses.map((statusItem) => {
                  return (
                    <MenuItem value={statusItem?.status_type}>
                      {/* <Checkbox
                        checked={}
                      /> */}
                      <ListItemText
                        sx={{ p: 1 }}
                        primary={`${statusItem?.status_en} (${statusItem?.count})`}
                      />
                      {state.currentStatus === statusItem?.status_en && (
                        <CheckIcon color="success" />
                      )}
                    </MenuItem>
                  );
                })}
                <MenuItem
                  disabled
                  sx={{
                    fontSize: ".8rem",
                    fontWeight: "bold",
                    background: "inherit",
                    opacity: "1 !important",
                    color: "black",
                  }}
                >
                  Active Sellers
                </MenuItem>
                {activeStatuses.map((statusItem) => {
                  return (
                    <MenuItem value={statusItem?.status_type}>
                      {/* <Checkbox
                        checked={}
                      /> */}
                      <ListItemText
                        sx={{ p: 1 }}
                        primary={`${statusItem?.status_en} (${statusItem?.count})`}
                      />
                      {state.currentStatus === statusItem?.status_en && (
                        <CheckIcon color="success" />
                      )}
                    </MenuItem>
                  );
                })}
              </Select>}
            </FormControl>
          )}
        </Box>

      </>
    </>
  );
};
export default Filter;
